import { useIdentity } from '@interhyp/platform-auth';

export function useIsCustomer(): boolean {
  return useIdentity()?.userType === 'CUSTOMER';
}
